import { instance as axios } from '../index'

/** 获取医生收藏处方列表 */ 
export const getDoctorFavoritePrescriptionList = (params) => {
  return axios.get('/base-data/doctorPrescriptionLibrary/getDoctorFavoritePrescriptionList', { params })
}

/** 获取处方列表 */ 
export const doctorPrescriptionLibraryList = (params) => {
  return axios.get('/base-data/doctorPrescriptionLibrary/list', { params })
}

/** 获取科别类型科别科室疾病树结构信息（校验医生权限） */ 
export const getDiseaseListByDoctorAuth = (params) => {
  return axios.get('/medicinal-service/disease/getDiseaseListByDoctorAuth', { params })
}

/** 新增处方 */ 
export const doctorPrescriptionLibraryAdd = (data) => {
  return axios.post('/base-data/doctorPrescriptionLibrary/add', data)
}

/** 更新处方 */ 
export const doctorPrescriptionLibraryUpdate = (data) => {
  return axios.put('/base-data/doctorPrescriptionLibrary/update', data)
}

/** 删除处方 */ 
export const doctorPrescriptionLibraryDelete = (id) => {
  return axios.delete(`/base-data//doctorPrescriptionLibrary/delete/${id}`)
}

/** 药品数据 */ 
export const baseMedicineList = (data) => {
  return axios.post(`/medicinal-service/baseMedicine/list`, data)
}

/** 获取药品列表 */ 
export const getMedicineList = (params) => {
  return axios.get('/medicinal-service/medicine/findList', { params })
}

/** 根据证型ID获取方剂列表 */ 
export const getSymptomTypePrescriptionBySymptomTypeId = (data) => {
  return axios.post('/medicinal-service/prescription/getSymptomTypePrescriptionBySymptomTypeId', data)
}